import { __assign } from "tslib";
import React, { useCallback } from 'react';
import styles from './styles.css.js';
import { AnnotationIcon } from './annotation-icon';
import useFocusVisible from '../../internal/hooks/focus-visible/index.js';
export default React.forwardRef(function AnnotationTrigger(_a, ref) {
    var open = _a.open, onClickHandler = _a.onClick, i18nStrings = _a.i18nStrings;
    var focusVisible = useFocusVisible();
    var onClick = useCallback(function (event) {
        event.preventDefault();
        onClickHandler();
    }, [onClickHandler]);
    return (React.createElement("button", __assign({ ref: ref, className: styles.hotspot, "aria-haspopup": "dialog", "aria-label": i18nStrings.labelHotspot(open), onClick: onClick }, focusVisible),
        React.createElement(AnnotationIcon, { open: open })));
});
//# sourceMappingURL=annotation-trigger.js.map